exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-type-section .report-type-section-inner[data-v-f217b618] {\n  display: flex;\n  flex-direction: column;\n}\n.report-type-section .report-type-section-inner .report-type-section-inner-detail[data-v-f217b618] {\n  flex: 1 1 auto;\n}\n.report-type-section ul[data-v-f217b618] {\n  list-style: none;\n}\n.report-type-section ul li[data-v-f217b618] {\n  font-size: 18px;\n  line-height: 24px;\n}", ""]);

// exports
